/* eslint-disable max-len */
/**
 * Spanish translations.
 */
export default {
  ACTION: {
    CAMPAIGNS: 'Campañas',
    CERTIFICATES: 'Certificados',
    CHALLENGES: 'Desafíos',
    CHAT: 'Chat',
    CLOSE: 'Cerrar',
    CLUB: 'Club',
    COMMISSIONED_PRODUCTS: 'Productos encargados',
    COMMUNICATIONS: 'Comunicaciones',
    CONFIRM: 'Confirmar',
    COUNTERPART: 'Contraprestaciones',
    DASHBOARD: 'Panel de control',
    DESIGN_REQUESTS: 'Solicitudes de diseño',
    DETAILS: 'Detalles',
    EXTERNAL_APPLICATIONS: 'Aplicaciones externas',
    FOLLOWER_MESSAGES: 'Mensajes de seguidores',
    GENERICS: 'Genéricas',
    LINKS: 'Enlaces',
    LIVE: 'Directos',
    LOGOUT: 'Cerrar sesión',
    MEMBERS: 'Miembros',
    MENTIONS: 'Menciones',
    OFFERS: 'Ofertas',
    ON_DEMAND_CAMPAIGNS: 'Campañas on demand',
    OPPORTUNITIES: 'Oportunidades',
    ORDERS: 'Pedidos pagados',
    PARTNERS: 'Socios',
    PERSONAL_AREA: 'Área personal',
    PRODUCTS_OFFERED: 'Productos ofrecidos',
    PROFILE: 'Perfil',
    PROZIS_COMMUNITY: 'Comunidad Prozis',
    QUESTIONS: 'Cuestiones',
    REMUNERATIONS: 'Remuneraciones',
    SELECT_LANGUAGE: 'Seleccionar idioma',
    SELECT_PARTNER: 'Seleccionar otro afiliado',
    SERVICES: 'Servicios',
    SOCIAL_NETWORK: 'Red social Prozis',
    STATISTICS: 'Estadísticas',
    VIDEO_TUTORIALS: 'Vídeos tutoriales'
  },
  ERROR: {
    ERROR: 'Error',
    FETCH_DATA: 'Recuperar datos'
  },
  HEADER: {},
  LABEL: {
    CAMPAIGNS: 'Campañas',
    CHALLENGES: 'Desafíos',
    CHAT: 'Chat',
    COMMUNICATIONS: 'Comunicaciones',
    COUNTERPARTS: 'Contraprestaciones',
    DASHBOARD: 'Panel de control',
    DESIGN_REQUESTS: 'Solicitudes de diseño',
    DETAILS: 'Detalles',
    EXTERNAL_APPLICATIONS: 'Aplicaciones externas',
    FILTER: 'Filtrar',
    FILTERED: 'Filtrado',
    FOLLOWER_MESSAGES: 'Mensajes de seguidores',
    GENERICS: 'Genéricas',
    HOME: 'Inicio',
    LINKS: 'Enlaces',
    LOGOUT: 'Cerrar sesión',
    MEMBERS: 'Socios',
    MENTIONS: 'Menciones de instagram',
    NOT_FOUND: '404. ¿Te has perdido?',
    OFFERS: 'Ofertas',
    ORDERS: 'Pedidos',
    PARTNERSHIP_NOT_FOUND: 'No se han encontrado afiliaciones.',
    PENDING_COUNTERPART: 'Contraprestaciones pendientes del período anterior',
    PENDING_COUNTERPART_CURRENT: 'Contraprestaciones pendientes del mes actual',
    PENDING_REMUNERATION: 'Remuneraciones pendientes del período anterior',
    PENDING_REMUNERATION_CURRENT: 'Remuneraciones pendientes del mes actual',
    PERSONAL_AREA: 'Área personal',
    PRODUCTS: 'Productos',
    REMUNERATIONS: 'Remuneraciones',
    SEARCH_PARTNERSHIP: 'Buscar afiliación',
    SELECT_LANGUAGE: 'Seleccionar idioma',
    SELECT_PARTNERSHIP: 'Seleccionar afiliación',
    UNAUTHROZIED: '403. ¡Acceso no autorizado!'
  },
  SENTENCE: {},
  SUCCESS: {},
  TOOLTIP: {}
};
